var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNavSignOut(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.7539 12.8477L16.2539 17.3477C15.9023 17.6992 15.375 17.6992 15.0586 17.3477C14.707 17.0312 14.707 16.5039 15.0586 16.1523L18.1172 13.0938H9.46875C8.97656 13.0938 8.625 12.7422 8.625 12.25C8.625 11.793 8.97656 11.4062 9.46875 11.4062H18.1172L15.0586 8.34766C14.707 8.03125 14.707 7.50391 15.0586 7.15234C15.375 6.83594 15.9023 6.83594 16.2539 7.15234L20.7539 11.6875C21.0703 12.0039 21.0703 12.5312 20.7539 12.8477ZM8.90625 6.0625H6.09375C5.28516 6.0625 4.6875 6.69531 4.6875 7.46875V17.0312C4.6875 17.8398 5.28516 18.4375 6.09375 18.4375H8.90625C9.36328 18.4375 9.75 18.8242 9.75 19.2812C9.75 19.7734 9.36328 20.125 8.90625 20.125H6.09375C4.37109 20.125 3 18.7539 3 17.0312V7.46875C3 5.78125 4.37109 4.375 6.09375 4.375H8.90625C9.36328 4.375 9.75 4.76172 9.75 5.21875C9.75 5.71094 9.36328 6.0625 8.90625 6.0625Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavSignOut);
export default __webpack_public_path__ + "static/media/navSignOut.6c15b6d0a5909e5b900d8040f818ebb5.svg";
export { ForwardRef as ReactComponent };